/**
 * FavoritesSection.jsx — PC 사이드바 '즐겨찾기' 칸 (2026-10-22)
 *
 * 자리: '내 정보' 바로 아래, '내 정보'가 없는 관리자는 상황판 바로 아래(사용자 확정 — 제목도 '내 정보'와 같은 모양).
 *   어떤 작업 대상을 골라도 같은 자리·같은 목록(내 정보 고정 규칙과 같다).
 * 하나도 없으면 칸 자체를 그리지 않는다(사용자 선택). 줄에 마우스를 올리면 ★ — 누르면 빠진다(MenuItem).
 * 회사에 묶인 칸은 회사 이름 첫 글자를 붙인다(통합 메뉴와 같은 표시, 작업 대상을 고를 수 있는 사람만).
 */
import React from 'react';
import MenuItem from './MenuItem';
import { favKey } from './favoriteCatalog';
import { companyBadges } from './integratedScope';
import { companyColor } from '../integratedmenu/integratedFeatureMeta';
import { useCompanyNames } from './useCompanyNames';

const upper = (v) => String(v || '').trim().toUpperCase();
const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

function CompanyMarks({ codes, hqCode, nameOf }) {
  return companyBadges(codes, hqCode, nameOf).map((b) => {
    const col = companyColor(b.code);
    return (
      <span
        key={b.code}
        title={b.name}
        className="rounded px-[3px] py-px text-[8px] font-black leading-none"
        style={{ background: col.bg, color: col.fg }}
      >
        {b.short}
      </span>
    );
  });
}

export default function FavoritesSection({ fav, pathname, hqCode, showMarks }) {
  const nameOf = useCompanyNames();
  if (!fav?.enabled || fav.items.length === 0) return null;
  return (
    <div className="px-2.5 pb-1 flex flex-col gap-[1px]">
      {/* 위 여백은 다른 묶음 제목과 같게(pt-2) — 바로 위 '내 정보'가 길면 그 칸이 스크롤되며 끝 줄이 잘려 붙어 보였다 */}
      <div className="text-[9px] font-black text-[var(--text-muted)] uppercase tracking-[0.08em] px-2 pt-2 pb-1">
        즐겨찾기
      </div>
      {fav.items.map((f) => {
        const codes = f.codes || (f.company ? [f.company] : []);
        // 지금 작업 대상 목록에 없는 회사(운영자의 다른 테넌트)는 저장해 둔 이름으로
        const nameFor = (c) => {
          const n = nameOf(c);
          return (n === String(c) && upper(c) === upper(f.company) && f.companyName) ? f.companyName : n;
        };
        return (
          <MenuItem
            key={favKey(f)}
            to={f.to}
            label={f.label}
            Icon={f.Icon}
            isActive={fav.isHere(f, pathname)}
            onClick={(e) => { if (plainClick(e)) { e.preventDefault(); fav.open(f); } }}
            favEntry={f}
            badges={showMarks && codes.length > 0 ? <CompanyMarks codes={codes} hqCode={hqCode} nameOf={nameFor} /> : null}
          />
        );
      })}
    </div>
  );
}
